export default __webpack_public_path__ + "static/media/arm.85c97d46.jpg";